export default __webpack_public_path__ + "images/yelp2.png";